{
  "corporatePortal": {
    "corporateDetails": {
      "partnerServices": "Partner services",
      "chooose": {
        "title": "Finnair for Business SAF service",
        "tag": {
          "notAdmin": "Available only for administrator role",
          "available": "Available",
          "notActivated": "Not activated"
        },
        "viewEmissions": "View reports",
        "activate": "Activate"
      }
    },
    "widgets": {
      "safWidget": {
        "activated": {
          "title": "Manage your emissions",
          "description": "You can now track carbon emissions associated with your company’s work travel and purchase SAF environmental attributes, which can be used to reduce your company’s carbon footprint. You can also get email notifications when new reports are ready for review."
        },
        "notActivated": {
          "title": "Start managing your emissions",
          "description": "Start reducing CO<sub>2</sub> emissions and tracking your business travel emissions by contributing to sustainable aviation fuel use. Activate your Finnair for Business SAF service to get started!"
        },
        "readMore": "Read more",
        "activate": "Activate",
        "viewEmissions": "View emissions",
        "activateModalTitle": "Activate Finnair for Business SAF Service",
        "activateButtonForCompany": "Activate company account",
        "activateButtonForUser": "Activate my account",
        "sustainabilityServicesForCompany": "What is the SAF Service?",
        "sustainabilityServicesTextForCompany": "<p class=\"ms-medium-b\">Finnair works in partnership with Chooose, enabling your company to view its employees’ flight emissions and reduce its net carbon emissions by contributing to sustainable aviation fuel (SAF) purchases.</p><p class=\"ms-medium-b\">Start by activating the service for your company. Administrators can access this service via the Finnair for Business Portal.</p>",
        "sustainabilityServicesForUser": "Sustainability services",
        "sustainabilityServicesTextForUser": "<p class=\"ms-medium-b\">Finnair works in partnership with Chooose, enabling your company to view its employees’ flight emissions and reduce its net carbon emissions by contributing to sustainable aviation fuel (SAF) purchases.</p><p class=\"ms-medium-b\">Start by activating your account. Administrators can access this service via the Finnair for Business Portal.</p>",
        "howItWorks": "How it works",
        "howItWorksOptions": [
          "Data from your employees' trips is used to calculate your emissions when they use your Finnair for Business number.",
          "You can view the emissions and purchase SAF environmental attributes, which will reduce your carbon footprint.",
          "You will receive a SAF certificate and can use it in reporting."
        ],
        "acceptTerms": {
          "label": "I have read, understood and accept the policy for data management as explained in",
          "linkText": "Finnair terms and conditions",
          "required": "Accept Terms and Condition to proceed"
        },
        "credentialsModalTitle": "Activate sustainability services",
        "checkYourEmail": "Check your email",
        "checkYourEmailText": "Our partner Chooose has sent you an invitation to {email}. Click the link to activate your account."
      }
    },
    "redirectingToPartnerSite": "Redirecting to Finnair for Business SAF partner",
    "redirectDescription": "Finnair for Business SAF Service is provided by Chooose. We work together to help you make impactful CO₂ reductions with audited certifications."
  }
}
